<template>
    <div>
        <EncabezadoCard
                :titulo="'Iniciar Sesión'"
                :sub-titulo="'Ingrese su cuenta'"
                :icono="'mdi-account'"
                style="background-color: #FAFAFA"
        ></EncabezadoCard>

        <v-form @submit.prevent="buscarCuenta" ref="form" v-model="valid"
                lazy-validation>

            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12" xs="12">

                            <v-text-field label="Cuenta (*)"
                                          required
                                          :counter="20"
                                          maxlength="20"
                                          v-model="cuenta"
                                          id="cuenta"
                                          :rules="[v => !!v || 'Cuenta es requerida',
                                                           v => (v && v.length <= 20 && v.length>=5) || 'La Cuenta debe contener al menos 5 caracteres']"
                            ></v-text-field>
                        </v-col>
                    </v-row>

                </v-container>

            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn type="submit" color="primary" class="pl-4 pr-4" :disabled="loading"> Siguiente
                    <v-progress-circular
                            v-if="loading"
                            indeterminate
                            color="primary"
                            style="margin-left: 10px"
                    ></v-progress-circular>
                    <v-icon left>mdi-arrow-right-bold</v-icon>
                </v-btn>
            </v-card-actions>

        </v-form>
    </div>
</template>
<script>
    import EncabezadoCard from "../../components/EncabezadoCard";
    import {mapState} from "vuex";

    export default {
        name: "cuenta-login",
        components: {EncabezadoCard},

        data: () => ({
            cuenta: '',
            loading: false,
            valid: false,
        }),
        mounted() {
            document.getElementById("cuenta").focus();
        },
        methods: {
            buscarCuenta() {
                if (!this.$refs.form.validate()) {
                    return;
                }

                this.loading = true;
                this.axios.get(this.url_base + "buscar_usuario/" + this.cuenta).then(response => {
                    if (response.data.res) {
                        this.$emit('setMiUsuario', response.data);
                    } else {
                        this.$toastr.error(response.data.message);
                    }
                    this.loading = false;
                }).catch(e => {
                    this.$toastr.error(e.response.data.message.error);
                    this.loading = false;
                })
            }
        },
        computed: {
            ...
                mapState(['url_base'])
        }
    }
</script>

<style scoped>

</style>